"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var UserName = function UserName(_ref) {
  var user = _ref.user;

  var rankClasses = function rankClasses(rank) {
    return rank ? "\n  ".concat(rank.isBold ? 'rank--bold' : '', "\n  ").concat(rank.isItalic ? 'rank--italic' : '', "\n  ").concat(rank.isUnderline ? 'rank--underlined' : '', "\n  ") : '';
  };

  return (0, _preact.h)("span", {
    className: "user-title ".concat(rankClasses(user.rank)),
    style: {
      color: user.rank ? user.rank.color : ''
    }
  }, user.userTitle);
};

var _default = UserName;
exports.default = _default;